<template>
  <div id="section9" class="page-section9">
    <img src="/img/ornamen_bunga.png" alt="Ornamen Kiri" loading="lazy" class="s9-ornamen-tl fade-on-scroll">
    <img src="/img/ornamen_bunga.png" alt="Ornamen Kanan" loading="lazy" class="s9-ornamen-tr fade-on-scroll">

    <h2 class="s9-title fade-on-scroll">Wedding Wishes</h2>
    <p class="s9-subtitle fade-on-scroll">Sampaikan doa dan ucapan terbaik Anda</p>

    <form class="s9-form fade-on-scroll" @submit.prevent="submitWish">
      <input v-model="form.nama" type="text" class="s9-input" placeholder="Isikan Nama" required>
      <textarea v-model="form.ucapan" class="s9-textarea" placeholder="Tuliskan Pesan dan Doa" rows="3" required></textarea>
      <select v-model="form.kehadiran" class="s9-select" required>
        <option value="" disabled>Konfirmasi Kehadiran</option>
        <option value="hadir">Hadir</option>
        <option value="tidak-hadir">Tidak Hadir</option>
        <option value="tentative">Tentative</option>
      </select>
      <button type="submit" class="s9-btn-submit" :disabled="isSubmitting">
        {{ isSubmitting ? 'Mengirim...' : 'Kirim Ucapan' }}
      </button>
    </form>

    <div class="s9-wishes-list fade-on-scroll">
      <div v-for="(wish, i) in wishesList" :key="i" class="wish-item">
        <img src="/img/Wayang-logo.png" alt="Avatar" loading="lazy" class="wish-avatar">
        <div class="wish-content">
          <div class="wish-header">
            <span class="wish-name">{{ wish.name }}</span>
            <span class="badge" :class="badgeClass(wish.confirmation)">{{ badgeLabel(wish.confirmation) }}</span>
          </div>
          <span class="wish-time">{{ timeAgo(wish.created_at) }}</span>
          <p class="wish-text">{{ wish.comment }}</p>
        </div>
      </div>
      <p v-if="!wishesList.length && !isLoading" class="no-wishes">Jadilah yang pertama memberikan ucapan 🤍</p>
      <p v-if="isLoading" class="no-wishes">Memuat ucapan...</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { useInvitationStore } from '@/store';
import moment from 'moment';

export default {
  name: 'WishesSection',
  data() {
    return {
      form: { nama: '', ucapan: '', kehadiran: '' },
      isSubmitting: false,
      isLoading: false,
      wishesList: [],
    };
  },
  computed: {
    ...mapState(useInvitationStore, ['client']),
  },
  mounted() {
    this.setupFadeObserver();
    this.fetchWishes();
  },
  beforeUnmount() {
    if (this._fadeObserver) this._fadeObserver.disconnect();
  },
  methods: {
    badgeClass(kehadiran) {
      if (kehadiran === 'hadir') return 'bdg-hadir';
      if (kehadiran === 'tidak-hadir' || kehadiran === 'tidak') return 'bdg-tidak';
      return 'bdg-tentative';
    },
    badgeLabel(kehadiran) {
      if (kehadiran === 'hadir') return 'Hadir';
      if (kehadiran === 'tidak-hadir' || kehadiran === 'tidak') return 'Tidak Hadir';
      return 'Tentative';
    },
    timeAgo(dateStr) {
      return dateStr ? moment(dateStr).fromNow() : '';
    },
    async fetchWishes() {
      if (!this.client || !this.client.id) return;
      this.isLoading = true;
      try {
        const response = await this.$api.get('comment/' + this.client.id);
        const raw = response.data.data;
        this.wishesList = Array.isArray(raw) ? raw : (Array.isArray(raw?.data) ? raw.data : []);
      } catch (e) {
        console.error('Gagal mengambil ucapan:', e);
      } finally {
        this.isLoading = false;
      }
    },
    async submitWish() {
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      try {
        await this.$api.post('comment', {
          client_id: this.client.id,
          name: this.form.nama,
          comment: this.form.ucapan,
          confirmation: this.form.kehadiran,
        });
        // Prepend new wish to local list with matching format
        this.wishesList.unshift({
          name: this.form.nama,
          comment: this.form.ucapan,
          confirmation: this.form.kehadiran,
          created_at: new Date().toISOString(),
        });
        this.form = { nama: '', ucapan: '', kehadiran: '' };
      } catch (e) {
        console.error('Gagal mengirim ucapan:', e);
      } finally {
        this.isSubmitting = false;
      }
    },
    setupFadeObserver() {
      if (typeof IntersectionObserver === 'undefined') return;
      const observer = new IntersectionObserver(
        (entries) => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('is-visible'); }),
        { threshold: 0.1 }
      );
      this.$el.querySelectorAll('.fade-on-scroll').forEach(el => observer.observe(el));
      this._fadeObserver = observer;
    },
  },
};
</script>

<style scoped>
.fade-on-scroll { opacity: 0; transform: translateY(40px); transition: opacity 1s ease-out, transform 1s ease-out; }
.fade-on-scroll.is-visible { opacity: 1; transform: translateY(0); }

.page-section9 {
  background-color: #5D7187; padding: 5rem 1.5rem 6rem; position: relative; overflow: hidden;
  color: #ffffff; display: flex; flex-direction: column; align-items: center;
}
.s9-ornamen-tl { position: absolute; top: -30px; left: -50px; width: 200px; transform: rotate(70deg); opacity: 0.9; z-index: 0; }
.s9-ornamen-tr { position: absolute; top: -30px; right: -50px; width: 200px; transform: scaleX(-1) rotate(70deg); opacity: 0.9; z-index: 0; }
.s9-title { font-family: 'Great Vibes', cursive; font-size: 3.5rem; font-weight: normal; margin-bottom: 0.2rem; text-align: center; position: relative; z-index: 1; }
.s9-subtitle { font-family: 'Cormorant Garamond', serif; font-size: 1.1rem; text-align: center; margin-bottom: 2rem; position: relative; z-index: 1; }
.s9-form { width: 100%; max-width: 500px; display: flex; flex-direction: column; gap: 12px; margin-bottom: 3rem; position: relative; z-index: 1; }
.s9-input, .s9-textarea, .s9-select {
  width: 100%; padding: 12px 16px; border-radius: 8px; border: none;
  background-color: #ffffff; font-family: 'Cormorant Garamond', serif; font-size: 1.05rem; color: #0F1A2C; font-weight: 600;
}
.s9-input::placeholder, .s9-textarea::placeholder { color: #4A5C74; font-weight: 500; opacity: 0.8; }
.s9-select:invalid { color: #4A5C74; font-weight: 500; }
.s9-select {
  appearance: none; -webkit-appearance: none;
  background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%234a5c74%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.2%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E");
  background-repeat: no-repeat; background-position: right .7rem top 50%; background-size: .65rem auto;
}
.s9-textarea { resize: vertical; }
.s9-btn-submit {
  align-self: flex-start; padding: 10px 24px; border-radius: 8px; border: 1.5px solid #ffffff;
  background-color: transparent; color: #ffffff; font-family: 'Cormorant Garamond', serif;
  font-size: 1rem; font-weight: 600; cursor: pointer; transition: background-color 0.3s, color 0.3s; margin-top: 8px;
}
.s9-btn-submit:hover, .s9-btn-submit:disabled { background-color: #ffffff; color: #5D7187; }
.s9-wishes-list {
  width: 100%; max-width: 500px; display: flex; flex-direction: column; gap: 20px;
  position: relative; z-index: 1; max-height: 400px; overflow-y: auto; padding-right: 8px;
}
.s9-wishes-list::-webkit-scrollbar { width: 6px; }
.s9-wishes-list::-webkit-scrollbar-track { background: rgba(255,255,255,0.1); border-radius: 4px; }
.s9-wishes-list::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.5); border-radius: 4px; }
.wish-item { display: flex; gap: 12px; }
.wish-avatar { width: 48px; height: 48px; border-radius: 50%; object-fit: cover; background-color: #ffffff; padding: 4px; flex-shrink: 0; }
.wish-content { background-color: #ffffff; color: #333; padding: 16px; border-radius: 12px; border-top-left-radius: 0; width: 100%; position: relative; }
.wish-content::before { content: ''; position: absolute; top: 0; left: -10px; border-width: 0 10px 10px 0; border-style: solid; border-color: transparent #ffffff transparent transparent; }
.wish-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 4px; }
.wish-name { font-family: 'Cinzel', serif; font-size: 1rem; font-weight: 700; color: #0F1A2C; }
.badge { font-size: 0.7rem; padding: 2px 8px; border-radius: 12px; font-weight: 600; text-transform: uppercase; }
.bdg-hadir { background-color: #e6f4ea; color: #2ecc71; }
.bdg-tentative { background-color: #fff3e0; color: #f39c12; }
.bdg-tidak { background-color: #fdedec; color: #e74c3c; }
.wish-time { font-size: 0.75rem; color: #888; display: block; margin-bottom: 8px; }
.wish-text { font-family: 'Cormorant Garamond', serif; font-size: 1.1rem; line-height: 1.5; color: #1C2D4A; font-weight: 500; margin: 0; }
.no-wishes { color: rgba(255,255,255,0.7); font-family: 'Cormorant Garamond', serif; font-size: 1.1rem; text-align: center; }
</style>
